import { render, staticRenderFns } from "./AddPackingLinkSpecialBranch.vue?vue&type=template&id=bed9005e"
import script from "./AddPackingLinkSpecialBranch.vue?vue&type=script&lang=js"
export * from "./AddPackingLinkSpecialBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports